export const svgToBase64DataUrl = (svgMarkup: string): string => {
  const bytes = new TextEncoder().encode(svgMarkup);
  let binary = "";
  bytes.forEach(b => (binary += String.fromCharCode(b)));
  return "data:image/svg+xml;base64," + btoa(binary);
};
